import React from 'react'
import { Box, Typography, Stack, Chip, Button } from '@mui/material'
import DoneAllIcon from '@mui/icons-material/DoneAll'
import CheckCircleIcon from '@mui/icons-material/CheckCircle'

const QUALITY_COLOR_MAP = {
  buena: '#4caf50',
  regular: '#ff9800',
  mala: '#f44336',
}

const classifyLabel = label => {
  const lower = String(label || '').toLowerCase()
  if (lower.includes('buen') || lower.includes('good') || lower === 'simétrica' || lower === 'simetrica') return 'buena'
  if (lower.includes('mal') || lower.includes('bad') || lower.includes('poor') || lower === 'irregular') return 'mala'
  if (lower.includes('regular') || lower.includes('fair') || lower.includes('poco sim')) return 'regular'
  return null
}

const QualitySummaryBar = ({ qualityFields, values, onMarkAllGood, getOptionLabel }) => {
  const counts = { buena: 0, regular: 0, mala: 0, empty: 0 }

  qualityFields.forEach(({ name }) => {
    const val = values[name]
    if (!val) {
      counts.empty++
      return
    }
    const label = getOptionLabel ? getOptionLabel(name, val) : val
    const cls = classifyLabel(label)
    if (cls) counts[cls]++
    else counts.empty++
  })

  const total = qualityFields.length
  const allGood = counts.buena === total

  const overall =
    counts.mala > 0
      ? 'mala'
      : counts.regular > 0
        ? 'regular'
        : counts.buena > 0
          ? 'buena'
          : null

  const overallLabel =
    overall === 'buena'
      ? 'Buena'
      : overall === 'mala'
        ? 'Mala'
        : overall === 'regular'
          ? 'Regular'
          : 'Sin evaluar'

  const parts = []
  if (counts.buena > 0) parts.push(`${counts.buena} buena`)
  if (counts.regular > 0) parts.push(`${counts.regular} regular`)
  if (counts.mala > 0) parts.push(`${counts.mala} mala`)
  if (counts.empty > 0) parts.push(`${counts.empty} sin evaluar`)

  return (
    <Box
      sx={{
        p: 1.5,
        borderRadius: 2,
        border: '1px solid',
        borderColor: overall ? `${QUALITY_COLOR_MAP[overall]}60` : 'divider',
        bgcolor: overall ? `${QUALITY_COLOR_MAP[overall]}08` : 'transparent',
        mb: 2,
      }}
    >
      <Stack
        direction="row"
        justifyContent="space-between"
        alignItems="center"
        flexWrap="wrap"
        gap={1}
      >
        <Stack direction="row" alignItems="center" spacing={1}>
          <Chip
            icon={allGood ? <CheckCircleIcon /> : undefined}
            label={overallLabel}
            size="small"
            sx={{
              bgcolor: overall ? QUALITY_COLOR_MAP[overall] : 'action.disabledBackground',
              color: '#fff',
              fontWeight: 700,
              '& .MuiChip-icon': { color: '#fff' },
            }}
          />
          <Typography variant="caption" color="text.secondary">
            {parts.join(', ')}
          </Typography>
        </Stack>
        {!allGood && (
          <Button
            size="small"
            variant="outlined"
            color="success"
            startIcon={<DoneAllIcon />}
            onClick={onMarkAllGood}
            sx={{ textTransform: 'none', fontWeight: 600, minHeight: 32 }}
          >
            Todo Bueno
          </Button>
        )}
      </Stack>
    </Box>
  )
}

export default QualitySummaryBar
